module.exports = __webpack_public_path__ + "img/edit-sign-icon.2010ce17.svg";